
import { vHasPermi } from "./hasPermi";
// 全局注册 directive
export function setupDirective(app) {
  app.directive("hasPermi", vHasPermi);
}
